export default "__VITE_ASSET__C5d6gLcd__"